module.exports = __webpack_public_path__ + "media/Edvard Grieg - Anitras Dance.491b3c8e.mp3";